import { styled } from '@mui/material';

export const MainContainer = styled('div')({
  width: '100%',
  minHeight: '100vh',
  overflow: 'hidden',
  position: 'relative',
});

export const ContentWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isDrawerOpen' && prop !== 'isOnMobileApp',
})<{ isDrawerOpen: boolean; isOnMobileApp: boolean }>(({ isDrawerOpen, isOnMobileApp }) => ({
  width: isOnMobileApp ? '100%' : isDrawerOpen ? 'calc(100% - 360px)' : '100%',
  transition: 'width 0.3s ease',
}));

export const Content = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isOnMobileApp' && prop !== 'open' && prop !== 'isDetailScreen' && prop !== 'isAdminRoute',
})(({
  open,
  isOnMobileApp,
  isDetailScreen,
  isAdminRoute,
}: {
  open: boolean;
  isOnMobileApp: boolean;
  isDetailScreen: boolean;
  isAdminRoute: boolean;
}) => {
  const hasFixedHeight = (isDetailScreen || isAdminRoute) && !isOnMobileApp;
  const isCompactRoute = isDetailScreen || isAdminRoute;

  return {
    display: 'block',
    overflowY: 'auto',
    overflowAnchor: 'none',
    transition: 'all 0.3s ease',
    marginLeft: isOnMobileApp ? 0 : open ? '320px' : '72px',
    padding: isCompactRoute ? (isOnMobileApp && isDetailScreen ? 0 : '0 16px 16px') : '16px',
    marginTop: isDetailScreen && isOnMobileApp ? 0 : isOnMobileApp ? '15px' : '64px',
    ...(hasFixedHeight ? { height: 'calc(100vh - 64px)' } : {}),
    ...(isDetailScreen && !isOnMobileApp ? { paddingTop: '24px' } : {}),
  };
});
